/**
 * Design tokens for the promoter panel.
 *
 * The codebase styles components with inline `style={{}}` objects rather
 * than CSS modules/Tailwind, so this file is the single source of truth for
 * colors/spacing/etc. consumed from JS — pair with `global.css` (imported
 * once in index.js) for the handful of things inline styles can't express
 * (hover/focus/active states, keyframes).
 */

export const color = {
  // Neutrals — cool gray scale, not pure black/white
  gray50: "#f8f9fb",
  gray100: "#f1f2f6",
  gray200: "#e7e9f0",
  gray300: "#d8dae3",
  gray400: "#b0b3c1",
  gray500: "#8b8fa3",
  gray600: "#666a80",
  gray700: "#4a4d5e",
  gray800: "#2f303d",
  gray900: "#1a1b24",

  white: "#ffffff",

  // Brand accent
  primary50: "#f0eeff",
  primary100: "#e4e0ff",
  primary400: "#8a80ff",
  primary500: "#6c63ff",
  primary600: "#5850e0",
  primary700: "#4640b8",

  // Semantic
  success50: "#eafcf3",
  success500: "#16a34a",
  success700: "#0f7a37",
  danger50: "#fef2f2",
  danger500: "#e5484d",
  danger600: "#d33d42",
  warning50: "#fff8e6",
  warning500: "#c88a04",
  info50: "#eef6ff",
  info500: "#2f7ff2",

  border: "#e7e9f0",
  borderStrong: "#d8dae3",
  bg: "#f8f9fb",
  surface: "#ffffff",
  textPrimary: "#1a1b24",
  textSecondary: "#666a80",
  textMuted: "#9599ab",
};

export const radius = {
  sm: 8,
  md: 12,
  lg: 16,
  xl: 20,
  pill: 999,
};

export const shadow = {
  xs: "0 1px 2px rgba(20, 21, 40, 0.04)",
  sm: "0 1px 3px rgba(20, 21, 40, 0.06), 0 1px 2px rgba(20, 21, 40, 0.04)",
  md: "0 4px 12px rgba(20, 21, 40, 0.07), 0 1px 3px rgba(20, 21, 40, 0.05)",
  lg: "0 12px 32px rgba(20, 21, 40, 0.12)",
  focusRing: "0 0 0 3px rgba(108, 99, 255, 0.18)",
};

export const space = (n) => n * 4; // 4px base unit — space(3) = 12, space(5) = 20

export const font = {
  xs: 11.5,
  sm: 12.5,
  base: 13.5,
  md: 14.5,
  lg: 16,
  xl: 18,
  xxl: 22,
  xxxl: 26,
};

export const transition = "150ms cubic-bezier(0.4, 0, 0.2, 1)";

/**
 * Breakpoints (max-width, px) — mirrors the thresholds `useViewport`
 * (src/hooks/useViewport.js) uses to classify the current window, so CSS
 * media queries in global.css and JS-side conditional inline styles agree on
 * where "mobile"/"tablet"/"desktop" start and end.
 */
export const breakpoint = {
  mobile: 640,  // ≤640px: phones
  tablet: 1024, // 641–1024px: tablets / small laptops
};
